var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 43 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .673)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 43,
    height: 43,
    rx: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F6F8FA",
    cx: 21.686,
    cy: 21.693,
    rx: 13.134,
    ry: 13.139
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.754 18.423c1.453 0 2.633-1.142 2.633-2.548 0-1.408-1.18-2.548-2.633-2.548-1.454 0-2.633 1.14-2.633 2.548 0 1.406 1.179 2.548 2.633 2.548M26.505 24.522l-3.332-1.16-1.16-3.03a2.18 2.18 0 0 0-.236-.62l-.002-.004a2.222 2.222 0 0 0-1.205-.992c-1.185-.413-2.501.187-2.939 1.341l-2.211 5.809a2.152 2.152 0 0 0 .323 2.103l-.002.002 3.536 4.41.171 5.177c-.003.614.509 1.11 1.141 1.106.633-.003 1.15-.504 1.153-1.12l.03-5.346c.008-.94-.328-1.285-1.188-2.52l-1.18-1.769c.125-.165.23-.348.307-.55l1.551-4.074.26.535c.204.508.484.895.852 1.023l3.54 1.232a.867.867 0 0 0 1.093-.499.81.81 0 0 0-.502-1.054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.294 37.871v-9.46a.401.401 0 0 0-.407-.395.401.401 0 0 0-.406.395c0 .265-.223.48-.497.48a.489.489 0 0 1-.496-.48c0-.748.627-1.356 1.4-1.356.772 0 1.4.608 1.4 1.356v9.46c0 .266-.222.48-.497.48a.489.489 0 0 1-.497-.48z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightHealthIcon);
export default __webpack_public_path__ + "static/media/highlightHealthIcon.8e526050f8cdbf20588275d77b63acff.svg";
export { ForwardRef as ReactComponent };